const ACTIVE_PROCESS_STATUSES = new Set([
    'pending',
    'uploading',
    'queued',
    'processing'
]);

export function hasActiveProcesses(processes) {
    return processes.some(process => ACTIVE_PROCESS_STATUSES.has(process.status));
}

export { ACTIVE_PROCESS_STATUSES };
